// Ported verbatim from the Claude Design prototype -- Instagram stories,
// Instalaciones gallery, Nuestros trabajos gallery, Nosotros story/values,
// and the (hidden-by-default) testimonials slots.

export const HISTORIAS = [
  { label: 'Diseño de la semana', fecha: 'Hace 2 días' },
  { label: 'Nuevo tono de temporada', fecha: 'Hace 4 días' },
  { label: 'Antes y después', fecha: 'Hace 5 días' },
  { label: 'Detrás de cámaras', fecha: 'Hace 1 semana' },
  { label: 'Promo del mes', fecha: 'Hace 1 semana' },
  { label: 'Cabina nueva', fecha: 'Hace 2 semanas' },
];

export const INSTALACIONES = [
  { label: 'Vista general del local', nota: 'Toma amplia horizontal', ratio: '16/9', span: 2 },
  { label: 'Recepción', nota: 'Primer contacto al entrar', ratio: '1/1', span: 1 },
  { label: 'Estaciones de manicure', nota: 'Dos o tres estaciones en uso', ratio: '1/1', span: 1 },
  { label: 'Estación de pedicure', nota: 'Silla y detalle de sales', ratio: '1/1', span: 1 },
  { label: 'Cabinas de masaje', nota: 'Con luz cálida encendida', ratio: '1/1', span: 1 },
  { label: 'Área de pestañas', nota: 'Camilla y lámpara de trabajo', ratio: '1/1', span: 1 },
  { label: 'Sala de espera', nota: 'Sillón, revistas, agua', ratio: '1/1', span: 1 },
  { label: 'Detalles decorativos', nota: 'Flores, textura, monograma', ratio: '16/9', span: 2 },
];

export const TRABAJOS = [
  { label: 'Nude con french invertido', cat: 'Uñas', ratio: '3/4' },
  { label: 'Nail art floral a mano', cat: 'Nail art', ratio: '1/1' },
  { label: 'Acrílico almendra largo', cat: 'Acrílico', ratio: '4/5' },
  { label: 'Gel efecto cristal', cat: 'Gel', ratio: '1/1' },
  { label: 'Pedicure rojo clásico', cat: 'Pedicure', ratio: '3/4' },
  { label: 'Volumen ruso denso', cat: 'Pestañas', ratio: '4/5' },
  { label: 'Cromo espejo', cat: 'Nail art', ratio: '1/1' },
  { label: 'Baby boomer', cat: 'Acrílico', ratio: '3/4' },
  { label: 'Lifting antes y después', cat: 'Pestañas', ratio: '1/1' },
  { label: 'Semipermanente lila', cat: 'Uñas', ratio: '4/5' },
  { label: 'Encapsulado con flor seca', cat: 'Nail art', ratio: '3/4' },
  { label: 'Pedicure spa terminado', cat: 'Pedicure', ratio: '1/1' },
];

export const TRABAJOS_FILTROS = ['Todo', 'Uñas', 'Nail art', 'Acrílico', 'Gel', 'Pedicure', 'Pestañas'];

export const NUESTRA_HISTORIA = [
  {
    titulo: 'Qué es Zenya',
    texto:
      'Zenya es un salón de uñas y spa en Puebla donde se hacen pocas cosas y se hacen bien: manicure, pedicure, pestañas, faciales y masaje. No somos una cadena ni un lugar de paso. Trabajamos con cita para que cada clienta tenga su tiempo y su espacio, sin prisa y sin fila.',
  },
  {
    titulo: 'Origen',
    texto:
      'Empezó en una sola mesa, con una técnica, un torno y una lista de clientas que cabía en una libreta. Las primeras citas fueron de conocidas que llegaron por recomendación. El local vino después, cuando la libreta ya no alcanzó y quedó claro que hacía falta un lugar propio para atender como queríamos.',
  },
  {
    titulo: 'Motivación',
    texto:
      'Nos cansamos de los lugares donde te apuran, te lastiman la cutícula y te entregan un trabajo que dura una semana. Zenya nació de querer lo contrario: técnica cuidada, material esterilizado, honestidad al decirte qué conviene a tu uña o a tu piel, aunque no sea lo más caro del menú.',
  },
  {
    titulo: 'Filosofía',
    texto:
      'Creemos que el cuidado personal no es un lujo ni una urgencia: es mantenimiento. Preferimos decirte que esperes dos semanas antes que hacerte un servicio que va a dañar tu uña. Preferimos una clienta que regresa doce veces al año a doce clientas que vienen una sola vez.',
  },
];

export const VALORES = [
  {
    titulo: 'Higiene sin excepción',
    texto: 'Todo el instrumental se esteriliza en autoclave y se abre frente a ti. No hay atajos en esto.',
  },
  {
    titulo: 'Técnica antes que moda',
    texto: 'Aprendemos la tendencia, pero primero está la salud de tu uña, tu piel y tu pestaña.',
  },
  { titulo: 'Tiempo respetado', texto: 'Trabajamos con cita y respetamos el horario. Tu hora es tuya.' },
  {
    titulo: 'Honestidad',
    texto: 'Si un servicio no te conviene, te lo decimos. Aunque signifique vender menos ese día.',
  },
];

// Hidden by default (see Testimonials component) -- only turn on once real
// client screenshots/videos exist. Do not write fake reviews.
export const TESTIMONIOS = [
  { tipo: 'Captura', label: 'Screenshot de comentario en Instagram', ratio: '9/16' },
  { tipo: 'Captura', label: 'Screenshot de reseña en Google', ratio: '9/16' },
  { tipo: 'Video', label: 'Testimonio en video de clienta', ratio: '9/16' },
  { tipo: 'Captura', label: 'Screenshot de mensaje de WhatsApp', ratio: '9/16' },
];

export const SELLOS = ['Material esterilizado', 'Atención con cita', 'Producto profesional', 'Estacionamiento cercano'];

export const MES_ACTUAL = 'Agosto 2026';
